import { put, takeEvery } from 'redux-saga/effects';
import { putWithToken } from '../../../api/network';
import {
  appNotify,
  setSelectedGroupIsLoading,
  updateShape,
  updateGroupShape,
  updateFieldValues
} from '../../../store/actions';

export function* updateShapeSaga() {
  yield takeEvery(updateShape, function* ({ payload }) {
    try {
      yield put(setSelectedGroupIsLoading(true));

      const url = `/api/assumptions/shapes`;
      yield putWithToken(url, payload);
      yield put(updateGroupShape(payload));
      yield put(setSelectedGroupIsLoading(false));
      yield put(appNotify(`${payload.shapeName} updated`, 'success'));
    } catch (error) {
      yield put(appNotify(`Failed to update shape: ${error.message}`, 'error'));
      yield put(setSelectedGroupIsLoading(false));
    }
  });

  yield takeEvery(updateFieldValues, function* ({ payload }) {
    try {
      const { updatedShapes, callback } = payload;
      yield put(setSelectedGroupIsLoading(true));
      let joinedFieldValues = [];
      for (const shape of updatedShapes) {
        joinedFieldValues = joinedFieldValues.concat(shape.fieldValues);
      };
      const url = `/api/assumptions/shapes/values`;
      yield putWithToken(url, { fieldValues: joinedFieldValues });
      for (const shape of updatedShapes) {
        yield put(updateGroupShape(shape));
      };
      yield put(setSelectedGroupIsLoading(false));
      yield put(appNotify(`${joinedFieldValues.length} values updated`, 'success'));
      callback && callback();
    } catch (error) {
      yield put(appNotify(`Failed to update values: ${error.message}`, 'error'));
      yield put(setSelectedGroupIsLoading(false));
    }
  });
}
